import BaseState from '@/store/base/state'

export default BaseState({
  moduleTitle: 'Employee schedule export',

  notificationTitle: 'title',
  primaryKey: 'uuid',
})
